import vue from 'vue'
import vuex from 'vuex'
import actions from '@/core/store/comum/actions'
import state from '@/core/store/comum/state'
import mutations from '@/core/store/comum/mutations'
import getters from '@/core/store/comum/getters'
import itemAdesao from '@/core/store/item-adesao'
import anuencia from '@/core/store/anuencia'
import ata from '@/core/store/ata'
import itens from '@/core/store/itens'
import documentos from '@/core/store/documentos'
import adesaoPublica from '@/core/store/adesao-publica'
import pedido from '@/core/store/pedido'
import relatorios from '@/core/store/relatorios'
import tipoDocumento from '@/core/store/tipo-documento'

vue.use(vuex)

export default new vuex.Store({
	actions,
	state,
	mutations,
	getters,
	modules: {
		itemAdesao,
		anuencia,
		ata,
		itens,
		documentos,
		adesaoPublica,
		pedido,
		relatorios,
		tipoDocumento,
	},
})
